import { createGlobalStyle } from 'styled-components'
import { calculateResponsiveSize, mediaMax } from '@dboxdev/ui-components'

export const palette = {
  black: '#000000',
  white: '#FFFFFF',
  cream: '#FBF6EC',
  sunrise: '#E6D0B0',
  umber: '#423427',
  olive: '#373D2E',
  creamLight: '#E9DDCD',
  warmWhite: '#FFFDF7'
}

export const themes = {
  Default: {
    colors: {
      textColor: palette.umber,
      backgroundColor: palette.cream,
      accentColor: palette.sunrise,
      placeholderColor: palette.olive
    },
    fonts: {
      primary: "'Lato', Arial, Helvetica, sans-serif",
      secondary: "'larken', Georgia, 'Times New Roman', serif"
    }
  }
}

export const defaultTheme = 'Default'

// Layer 3 — project-only rules, layered on top of the packaged BaseGlobalStyles
// (reset) + ThemeGlobalStyles (brand) that LayoutProvider injects. Colors, the
// box-model reset, font-family, .for-mobile/.for-desktop and the Safari autofill
// fix all come from those two layers — don't repeat them here.
export const GlobalStyle = createGlobalStyle`
  /* How "dark" the panel under the fixed chrome currently is: 0 on cream, 1 over
     imagery, and any value between while two panels cross-fade. The landing page
     publishes it straight from the panel timeline, so the chrome resolves on the
     same frames as the panels themselves — no timer, no transition of its own,
     nothing that can drift out of step with the crossfade.
     Everything chrome-related derives from this one scalar: the header's shadow, the
     two header lockups, and the colour below. */
  :root {
    --chrome-dark: 0;
    --chrome-color: color-mix(
      in srgb,
      ${palette.creamLight} calc(var(--chrome-dark) * 100%),
      ${palette.umber}
    );
    /* The same mix with its ends swapped — what reads *against* the chrome. The
       header's Inquire pill fills with --chrome-color on hover and prints its
       label in this, in both directions. */
    --chrome-contrast: color-mix(
      in srgb,
      ${palette.umber} calc(var(--chrome-dark) * 100%),
      ${palette.creamLight}
    );
  }

  html, body {
    width: 100%;
    height: 100%;
    background: ${palette.white};
    font-size: ${calculateResponsiveSize(14)};
    line-height: 1.25;
  }
  body {
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  ${mediaMax('mobile')} {
    :root[data-deck],
    :root[data-deck] body {
      height: var(--panel-h, 100svh);
      overflow: hidden;
    }
  }
  body.hidden {
    height: 100dvh !important;
  }
  body.hidden .wrapper {
    height: 100dvh;
    overflow: hidden;
  }

  /* ----- Fix page transition ----- */
  .page.exiting,
  .page.exited {
    transition: none;
  }

  /* ----- Animations ----- */
  .fadeIn {
    opacity: 0;
    transition: opacity 1s;
    &.visible {
      opacity: 1;
    }
  }
  .fadeInFromBottom {
    transform: translateY(${calculateResponsiveSize(30)});
    opacity: 0;
    transition: transform 1.4s, opacity 1.4s;
    &.visible {
      transform: translateY(0);
      opacity: 1;
    }
  }
`
